
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debates",
      function () {
        return require("private-next-pages/debates.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debates"])
      });
    }
  